import {getUserData} from '@common'
import {APIMethod} from '@enums'
import {getUserSelectionAtom} from '@state'

import {fetchData} from 'api/api'
import {getDefaultStore} from 'jotai'

import {ContractRequest, ContractResponse, ContractStatsResponse, LegacyContractDataResponse} from './types'

export const getContracts = async (): Promise<ContractResponse[]> => {
  const currentUser = getUserData()
  const userSelectionMap = getDefaultStore().get(getUserSelectionAtom)
  const userSelection = userSelectionMap[currentUser.id]

  return fetchData({
    method: APIMethod.GET,
    url: `contract/company/${userSelection?.companyId || ''}`,
  })
}

export const getLegacyContracts = async (): Promise<LegacyContractDataResponse[]> => {
  const currentUser = getUserData()
  const userSelectionMap = getDefaultStore().get(getUserSelectionAtom)
  const userSelection = userSelectionMap[currentUser.id]

  return fetchData({
    method: APIMethod.GET,
    url: `fabric/company/${userSelection?.companyId || ''}`,
  })
}

export const getLegacyContract = async (id: string): Promise<LegacyContractDataResponse> =>
  fetchData({
    method: APIMethod.GET,
    url: `fabric/${id}`,
  })

export const getContract = async (id: string): Promise<ContractResponse> =>
  fetchData({
    method: APIMethod.GET,
    url: `contract/${id}`,
  })

export const getContractsByCompany = async (id: string): Promise<ContractResponse[]> =>
  fetchData({
    method: APIMethod.GET,
    url: `contract/company/${id}`,
  })

export const createContract = async (body: ContractRequest): Promise<ContractResponse> =>
  fetchData({
    method: APIMethod.POST,
    url: `contract`,
    body,
  })

export const updateContract = async (body: ContractRequest, id: string): Promise<ContractResponse> =>
  fetchData({
    method: APIMethod.PUT,
    url: `contract/${id}`,
    body,
  })

export const getContractStatsByCompanyId = async (id: string): Promise<ContractStatsResponse[]> =>
  fetchData({
    method: APIMethod.GET,
    url: `contract/statistics/last-seven-days/company/${id}`,
  })

export const reserveContractCode = async (companyId: string): Promise<string> =>
  fetchData({
    method: APIMethod.POST,
    url: `contract/reserve-code?companyId=${companyId}`,
  })
